
import React from 'react';
import { connect } from 'react-redux';
import {DashboardContainer} from "../../../funcs/utils";
import {IAVError, IAVFlow, init_iav_flow_state} from "../../../payment/iav-flow";
import {config_to_url} from "../../../helper/url";


const AddPaymentSource_ = props => {

  const component = props.component;
  const host = config_to_url(props.app.config);
  const root_url = host + "/ugma-invite/payment-source";

  return (
    <DashboardContainer
      client={props.client}
      title={"Add Payment Source"}>
      <div align={"center"}>
        <IAVFlow
          url={root_url}
          component={component}
          state={component.state}
          button_text={"Login securely to your bank"}/>
      </div>
      <div align={"center"} style={{paddingTop: "1rem"}}>
        <IAVError component={component}/>
      </div>

    </DashboardContainer>
  )
}

const mapDispatchToProps = dispatch => {
  return {
  };
}

const mapStateToProps = state => {
  return {
    client: state.client,
    app: state.app,
  };
}

const init_state = () => {
  return init_iav_flow_state();
}

const AddPaymentSource = connect(mapStateToProps, mapDispatchToProps)(AddPaymentSource_);

export { AddPaymentSource, init_state };
